/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

export const selectRealtimeExchange = createSelector(
  (state: RootState) => state.rate.realtime,
  (realtime) => realtime.data
);
